import React, { useContext, useEffect, useState } from 'react';
import { LoadingContext } from '../../context/Loading';
import FormLogin from './FormLogin';
import { makeStyles, Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { AuthContext } from '../../context/Auth';

const LoginScreen = props => {

    const [ snackbar, setSnackbar ] = useState({ message: '', visible: false });
    const { setIsReady } = useContext(LoadingContext);
    const { isLogged } = useContext(AuthContext);
    const { history } =  props;

    const classes = useStyles();

    useEffect(() => {
        let subscribed = true;
      
        if(subscribed) {
            setIsReady(true);
            isLogged && history.replace('/dashboard');
        }
        
        return () => subscribed = false;
    }, [isLogged]);

    return (
        <div className={classes.container}>
            <FormLogin setSnackbar={setSnackbar} />
            <Snackbar open={snackbar.visible} autoHideDuration={6000} onClose={() => setSnackbar(e => ({...e, visible: false}))} className={classes.snackbar}>
                <Alert severity="error" variant='filled' className={classes.alert}>
                    { snackbar.message }
                </Alert>
            </Snackbar>
        </div>
    );
}

const useStyles = makeStyles({
    container: {
        background: '#00365F',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    snackbar: {
        width: '100%'
    },
    alert: {
        width: '100%', 
        marginLeft: 10, 
        marginRight: 10
    }
})

export default LoginScreen;